import { createModelStore } from '@/shared/stores/create-model-store'
import { model1_4InitialModel } from './initial-state'
import { model1_4DimensionHandlers } from './dimensions'

export const useModel1_4Store = createModelStore({
  initialModel: model1_4InitialModel,
  dimensionHandlers: model1_4DimensionHandlers,
})
